
import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from 'react-i18next';

const OutsourcingPilar13 = props => (
    <section id="outsourcing-pilar-section13" className="my pt-5 blue-bg">
        <div className='black-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingPilar:section-13.title')}</h2>
            {/* Text content */}
            <div className='mb-5'>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-13.1.title')}</h3>
                </div>
                <p className='m-0'><Trans>{props.t('services:outsourcingPilar:section-13.1.text')}</Trans></p>
            </div>
            {/* Text content */}
            <div>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-13.2.title')}</h3>
                </div>
                <p className='mb-5'><Trans>{props.t('services:outsourcingPilar:section-13.2.text')}</Trans></p>
            </div>
            {/* Text content */}
            <div>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-13.3.title')}</h3>
                </div>
                <p className='m-0'><Trans>{props.t('services:outsourcingPilar:section-13.3.text')}</Trans></p>
            </div>
            {/* Text content */}
            <div>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-13.4.title')}</h3>
                </div>
                <p className='m-0'><Trans>{props.t('services:outsourcingPilar:section-13.4.text')}</Trans></p>
            </div>
            {/* Text content */}
            <div>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-13.5.title')}</h3>
                </div>
                <p className='m-0'><Trans>{props.t('services:outsourcingPilar:section-13.5.text')}</Trans></p>
            </div>
            {/* Text content */}
            <div>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-13.6.title')}</h3>
                </div>
                <p className='m-0'><Trans>{props.t('services:outsourcingPilar:section-13.6.text')}</Trans></p>
            </div>
            {/* Text content */}
            <div>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-13.7.title')}</h3>
                </div>
                <p className='m-0'><Trans>{props.t('services:outsourcingPilar:section-13.7.text')}</Trans></p>
            </div>
            {/* Text content */}
            <div>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-13.8.title')}</h3>
                </div>
                <p className='m-0'><Trans>{props.t('services:outsourcingPilar:section-13.8.text')}</Trans></p>
            </div>
            {/* Text content */}
            <div>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-13.9.title')}</h3>
                </div>
                <p className='m-0'><Trans>{props.t('services:outsourcingPilar:section-13.9.text')}</Trans></p>
            </div>
            {/* Text content */}
            <div>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingPilar:section-13.10.title')}</h3>
                </div>
                <p className='m-0'><Trans>{props.t('services:outsourcingPilar:section-13.10.text')}</Trans></p>
            </div>
        </Container>
    </section>
);


export default OutsourcingPilar13;